export const status = {
    'active': 'Looking for a driver',
    'waiting for payment': 'Waiting for payment',
    'driver matched': 'Driver matched',
    'driver on the way': 'Driver on the way',
    'picked up': 'Item picked up',
    'delivery in progress': 'Delivery in progress',
    'completed': 'Completed',
    'canceled': 'Canceled',

    'dropoff origin': 'Origin Hub',
    'dropoff origin main': 'Origin - Main Hub',

    'transfer inprogress': 'Transfer In Progress',
    
    'dropoff destination main': 'Destination - Main Hub',
    'dropoff destination': 'Destination Hub',
    
    'for delivery': 'Ready For Delivery',
    'for pickup': 'Ready For Customer Pickup',    
};

export const renderStatusLabel = (status, orderType) => {
    let resultLabel = status[status] || status.toUpperCase();

    if (orderType == 'dropoff2dropoff' || orderType == 'dropoff2door') {
        switch (status) {
            case 'active':
                resultLabel = 'Waiting for the parcel to drop off';
                break;
        
            default:
                break;
        }
    }

    return resultLabel.toUpperCase();
}

export const regularLabels = {
    door2door: 'Door 2 Door',
    dropoff2dropoff: 'Dropoff 2 Dropoff',
    dropoff2door: 'Dropoff 2 Door',
    door2dropoff: 'Door 2 Dropoff',
};


export const customerCancelReason = {
    'active': [
        'Waiting for too long',
        'No need the service',
    ],
    'waiting for payment': [
        'No need the service',
        'Too expensive',
    ],
    'driver matched': [
        'Waiting for too long',
        'No need the service',
        'Issue with driver',
        'Found another courier'
    ],
    'driver on the way': [
        'Waiting for too long',
        'No need the service',
        'Issue with driver',
        'Found another courier'
    ],
    'picked up': [
        'Waiting for too long',
        'No need the service',
        'Issue with driver',
        'Found another courier'
    ],
    'delivery in progress': [
        'Waiting for too long',
        'No need the service',
    ],
    'dropoff origin': [
        'Waiting for too long',
        'No need the service',
    ],
    'dropoff origin main': [
        'Waiting for too long',
        'No need the service',
    ],
    'transfer inprogress': [
        'Waiting for too long',
        'No need the service',
    ],
    'dropoff destination main': [
        'Waiting for too long',
        'No need the service',
    ],
    'dropoff destination': [
        'Waiting for too long',
        'No need the service',
    ],
    'for delivery': [
        'Waiting for too long',
        'No need the service',
    ],
    'for pickup': [
        'Waiting for too long',
        'No need the service',
    ],
};

export const driverCancelReason = {
    'active': [
        'Waiting for too long',
        'Issue with customer',
        'Emergency'
    ],
    'waiting for payment': [
        'Waiting for too long',
        'Issue with customer',
        'Emergency'
    ],
    'driver matched': [
        'Waiting for too long',
        'Issue with customer',
        'Emergency'
    ],
    'driver on the way': [
        'Waiting for too long',
        'Issue with customer',
        'Emergency'
    ],
    'picked up': [
        'Waiting for too long',
        'Issue with customer',
        'Emergency'
    ],
    'delivery in progress': [
        'Waiting for too long',
        'Issue with customer',
        'Emergency'
    ],
    'dropoff origin': [
        'Waiting for too long',
        'Issue with customer',
        'Emergency'
    ],
    'dropoff origin main': [
        'Waiting for too long',
        'Issue with customer',
        'Emergency'
    ],
    'transfer inprogress': [
        'Waiting for too long',
        'Issue with customer',
        'Emergency'
    ],
    'dropoff destination main': [
        'Waiting for too long',
        'Issue with customer',
        'Emergency'
    ],
    'dropoff destination': [
        'Waiting for too long',
        'Issue with customer',
        'Emergency'
    ],
    'for delivery': [
        'Waiting for too long',
        'Issue with customer',
        'Emergency'
    ],
    'for pickup': [
        'Waiting for too long',
        'Issue with customer',
        'Emergency'
    ],
};